import api from "./api";

export async function deleteSlide(slide_id: string) {
  const res = await api.delete(`/slides/${slide_id}`);
  return res;
}
